import RaikoBaseDialogContentContainer
    from "../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import {
    RaikoMoneyInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, RaikoSimpleMultiLineInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {VowService} from "../../serverService/vow/VowService";
import {useState} from "react";

export default function VowAddNew({handleAddNewItemToTable}) {

    const service = new VowService()

    const [loading, setLoading] = useState(false)
    const [title, setTitle] = useState("")
    const [slug, setSlug] = useState("")
    const [price, setPrice] = useState("")
    const [description, setDescription] = useState("")


    function handleCreateItem() {
        setLoading(true)
        service.addNewVow(
            title,
            description,
            slug,
            price,
        ).then(response => {
            showSuccessMessage("نذر جدید با موفقیت افزوده شد.")
            handleAddNewItemToTable(response)
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoading(false)
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن نذر جدید"}
                hasActionButton
                actionButtonOnclickWithValidation={handleCreateItem}
                actionButtonLoadingState={loading}
            >
                <RaikoSimpleInputOutlined
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                    required
                />
                <RaikoSimpleInputOutlined
                    labelText={"SLUG"}
                    value={slug}
                    setValue={setSlug}
                    required
                    placeHolder={"حتما به زبان انگلیسی باشد."}
                />
                <RaikoMoneyInputOutlined
                    labelText={"مبلغ واحد (ریال)"}
                    value={price}
                    setValue={setPrice}
                    required
                />
                <RaikoSimpleMultiLineInputOutlined
                    labelText={"توضیحات"}
                    value={description}
                    setValue={setDescription}
                    required
                />
            </RaikoSectionContainer>
        </RaikoBaseDialogContentContainer>
    )
}